<p-toast></p-toast>

<app-page-shell>

    <app-page-detail-hero [auditStamp]="trailer ? { createdAt: trailer.createdAt, updatedAt: trailer.updatedAt } : null"
        icon="pi pi-ticket"
        eyebrow="Trailer Asset"
        [title]="trailer?.assetNumber || '-'"
        [subtitle]="(trailer?.trailerTypeName || '-') + ' | ' + (trailer?.plateNumber || '-')">
        <div tags>
            <p-tag [value]="trailer?.status || 'AVAILABLE'" [severity]="statusSeverity(trailer?.status)"></p-tag>
            <p-tag [value]="trailer?.active === false ? 'Inactive' : 'Active'" [severity]="activeSeverity(trailer?.active)"></p-tag>
        </div>
        <div actions>
            <p-button label="Back" icon="pi pi-arrow-left" severity="secondary" [outlined]="true" (onClick)="back()"></p-button>
            <p-button label="Edit" icon="pi pi-pencil" (onClick)="edit()"></p-button>
        </div>
    </app-page-detail-hero>

    <app-page-metric-strip [metrics]="metrics()"></app-page-metric-strip>

    <div class="detail-grid">
        <app-page-data-panel title="Asset Identity" subtitle="Trailer master-data fields.">
            <div class="info-grid">
                <div>
                    <span>Asset Number</span>
                    <strong>{{ trailer?.assetNumber || '-' }}</strong>
                </div>
                <div>
                    <span>Trailer Type</span>
                    <strong>{{ trailer?.trailerTypeName || '-' }}</strong>
                    <small>{{ trailer?.trailerTypeCode || '-' }}</small>
                </div>
                <div>
                    <span>Status</span>
                    <strong>{{ trailer?.status || '-' }}</strong>
                </div>
                <div>
                    <span>Active</span>
                    <strong>{{ trailer?.active === false ? 'Inactive' : 'Active' }}</strong>
                </div>
            </div>
        </app-page-data-panel>

        <app-page-data-panel title="Registration" subtitle="Plate, registration, and expiry metadata.">
            <div class="info-grid">
                <div>
                    <span>Plate Number</span>
                    <strong>{{ trailer?.plateNumber || '-' }}</strong>
                </div>
                <div>
                    <span>Registration Number</span>
                    <strong>{{ trailer?.registrationNumber || '-' }}</strong>
                </div>
                <div>
                    <span>Registration Expiry</span>
                    <strong>{{ dateLabel(trailer?.registrationExpiry) }}</strong>
                </div>
                <div>
                    <span>Insurance Expiry</span>
                    <strong>{{ dateLabel(trailer?.insuranceExpiry) }}</strong>
                </div>
            </div>
        </app-page-data-panel>
    </div>

    <app-page-data-panel title="Notes" subtitle="Operational notes stored on the trailer asset.">
        <p>{{ trailer?.notes || 'No notes.' }}</p>
    </app-page-data-panel>
</app-page-shell>
